import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import InviteInfoPanel from './Invite/InviteInfoPanel';

type PreLoginWithInviteInfoPanelProps = {
    children: React.ReactNode;
    brandingName: string;
    inviteType: string;
};
export default function PreLoginWithInviteInfoPanel({
    children,
    brandingName,
    inviteType
}: PreLoginWithInviteInfoPanelProps) {
    return (
        <Box sx={{ minHeight: '100vh', overflow: 'hidden', backgroundColor: 'inviteInfo.backgroundColor' }}>
            <Grid container sx={{ minHeight: '100%' }}>
                <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'auto',
                        order: { xs: 2, md: 1 }
                    }}
                >
                    {children}
                </Grid>
                <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'auto',
                        order: { xs: 1, md: 2 }
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: { xs: '50vh', md: '100%' },
                            p: { xs: 2, md: 4 }
                        }}
                    >
                        <InviteInfoPanel brandingName={brandingName} inviteType={inviteType} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
